import styled from "styled-components";
import {Table} from "antd";

export const CourierShiftTableContainer = styled(Table)`
    width: 100%;
    margin-top: 16px;
    @media screen and (max-width: 768px) {
        .ant-table-thead > tr > th {
            display: none;
        }
        .ant-table-tbody > tr > td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 16px !important;
        }
        .ant-table-tbody > tr > td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #333;
            text-align: left;
            flex-shrink: 0;
            font-size: 14px;
        }
        .ant-table-tbody > tr > td:first-child {
            border-top: 2px solid #dedcdc !important;
        }
        .ant-table-tbody > tr > td:last-child {
            border-bottom: 2px solid #dedcdc !important;
            margin-bottom: 16px;
            padding-bottom: 16px !important;
        }
    }
`;
